import { render, staticRenderFns } from "./keen-slider.vue?vue&type=template&id=fa936a22"
import script from "./keen-slider.vue?vue&type=script&lang=js"
export * from "./keen-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_css-loader@6.11.0_webpack@5.96.1_webpack-cl_9407c811182c271a25268cd88f02b9cb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/phuongle/Documents/Lespecs/SUN-543/lespecs/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa936a22')) {
      api.createRecord('fa936a22', component.options)
    } else {
      api.reload('fa936a22', component.options)
    }
    module.hot.accept("./keen-slider.vue?vue&type=template&id=fa936a22", function () {
      api.rerender('fa936a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/keen-slider.vue"
export default component.exports